import React, { useState, useEffect, useCallback } from "react";
import Performance from "../components/Performance/Performance";
import * as apis from "../apis";

const toStr = (v) => (v === null || v === undefined ? "" : String(v));
const onlyDigits = (s) => toStr(s).replace(/[^0-9]/g, "");
const addComma = (digits) =>
  toStr(digits).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
const stripComma = (s) => toStr(s).replace(/,/g, "");

export default function PerformanceContainer() {
  const [inputValue, setInputValue] = useState({
    salesYear: "",
    salesNumber: "",
    clientYear: "",
    clientNumber: "",
  });

  useEffect(() => {
    const fetchCompanyPerformance = async () => {
      const res = await apis.getCompanyPerformance();
      const data = res?.data?.data || {};
      // ✅ 서버값 정규화(문자열화) + 숫자 필드는 콤마 포맷
      setInputValue({
        salesYear: onlyDigits(data.salesYear),
        salesNumber: data.salesNumber
          ? addComma(onlyDigits(data.salesNumber))
          : "",
        clientYear: onlyDigits(data.clientYear),
        clientNumber: data.clientNumber
          ? addComma(onlyDigits(data.clientNumber))
          : "",
      });
    };
    fetchCompanyPerformance();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const digits = onlyDigits(value);

    if (name === "salesNumber" || name === "clientNumber") {
      setInputValue((prev) => ({ ...prev, [name]: addComma(digits) }));
    } else {
      // year 필드는 콤마 없이 숫자만
      setInputValue((prev) => ({ ...prev, [name]: digits }));
    }
  };

  // 숫자 변환 헬퍼
  const toInt = (s) => {
    const n = Number.parseInt(stripComma(s), 10);
    return Number.isNaN(n) ? 0 : n;
  };

  const handleSubmit = useCallback(async () => {
    if (!inputValue.salesYear.trim()) {
      alert("매출 연도를 작성해 주세요.");
      return;
    }
    if (!inputValue.salesNumber.trim()) {
      alert("매출을 작성해 주세요.");
      return;
    }
    if (!inputValue.clientYear.trim()) {
      alert("고객사 연도를 작성해 주세요.");
      return;
    }
    if (!inputValue.clientNumber.trim()) {
      alert("고객사 수를 작성해 주세요.");
      return;
    }

    try {
      const payload = {
        salesYear: toInt(inputValue.salesYear),
        salesNumber: toInt(inputValue.salesNumber), // 콤마 제거 후 숫자
        clientYear: toInt(inputValue.clientYear),
        clientNumber: toInt(inputValue.clientNumber), // 콤마 제거 후 숫자
      };

      if (window.confirm("회사 성과를 저장하시겠습니까?")) {
        await apis.updateCompanyPerformance(payload);
        alert("회사 성과가 저장되었습니다.");
      }
    } catch (error) {
      console.error(error);
      alert(
        error.response?.data?.message ||
          "회사 성과를 저장하는데 실패 하였습니다."
      );
    }
  }, [inputValue]);

  return (
    <Performance
      inputValue={inputValue}
      handleChange={handleChange}
      handleSubmit={handleSubmit}
    />
  );
}
